 
import { User } from "../types/user";
import { createApiStore } from "./genericStore";
 
export const useUserStore = createApiStore<User>("/user");
